import { useEffect } from "react";
import { usePage } from "@inertiajs/react";
import toast, { Toaster } from "react-hot-toast";

export default function PlainLayout({ children }) {
  const { props } = usePage();
  const flash = props?.flash || {};

  useEffect(() => {
    if (!flash.notice) return;

    toast.success(flash.notice);
  }, [flash?.key, flash?.notice]);

  useEffect(() => {
    if (!flash.alert) return;

    toast.error(flash.alert);
  }, [flash?.key, flash?.alert]);

  return (
    <div className="d-flex flex-column justify-content-center min-vh-100 position-relative">
      <Toaster position="bottom-center" />
      <main>{children}</main>
    </div>
  );
}
